import {FC, PropsWithChildren, ReactNode} from 'react';
import {Typography} from '../ui/typography';
import {cn} from '@/lib/utils';

interface EventSectionProps {
  label: string;
  /**
   * An additional element to include in the section header
   */
  adornment?: ReactNode;
  className?: string;
}

export const EventSection: FC<PropsWithChildren<EventSectionProps>> = ({
  adornment,
  children,
  className,
  label,
}) => (
  <div className={cn('flex flex-col gap-6', className)}>
    <div className="flex items-center gap-2">
      <Typography level="H4" className="italic font-semibold">
        {label}
      </Typography>
      {adornment}
    </div>
    {children}
  </div>
);
